const menuNavConfig = {
  expoHallHiddenLocales: ['ja', 'ko', 'ru', 'zh', 'zh-hans', 'zh-hant'],
  innovatorsLocales: ['en'],
}

export default menuNavConfig
